import Base from './base';

class GoogleAnalyticsAjaxHandlingEvent extends Base {
  readonly EVENT_CATEGORY = 'ajax_handling';

  error({
    path,
    staffId,
    time,
    message
  }: {
    staffId: string;
    path: string;
    time: string;
    message: string;
  }) {
    this.sendEvent({
      category: this.EVENT_CATEGORY,
      action: 'error',
      label: `staff:${staffId}-path:${path}-time:${time}-message:${message}`,
      nonInteraction: true,
    });
  }
}

export default new GoogleAnalyticsAjaxHandlingEvent();
